module.exports = __webpack_public_path__ + "img/tartinevert_on.ce48e236.gif";